<template>
  <div class="pagina-step">
    <span class="pagina-step-title">{{ cidadeEstado }}</span>
    <ValidationObserver ref="observer">
      <div class="container-table">
        <table>
          <tr>
            <th></th>
            <th></th>
          </tr>
          <tr v-for="(value, name) in form" :key="name">
            <td>{{ name }}</td>
            <td>
              <validation-provider v-slot="{ errors }" rules="required">
                <input
                  type="text"
                  v-model="form[name]"
                  :name="`${name}`"
                  v-inputmask="maskNumbers"
                />
                <div class="error">{{ errors[0] }}</div>
              </validation-provider>
            </td>
          </tr>
        </table>
      </div>
    </ValidationObserver>
    <div class="container-buttons">
      <button type="button" @click="voltar">Voltar</button>
      <button @click="proximo">Avançar</button>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    dados: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        'eSF 40h': '',
        'eAP 30h': '',
        'eAP 20h': '',
        'eMulti Ampliada': '',
        'eMulti Complementar': '',
        'eMulti Estratégica': '',
        'eSB I - Comum': '',
        'eSB II - Comum': '',
        'eSB I- Quil/Assent': '',
        'eSB II- Quil/Assent': '',
      },
    }
  },
  mounted() {
    if (this.dados?.etapa4 !== null) {
      const etapa4 = this.dados?.etapa4
      this.form['eSF 40h'] = etapa4['eSF 40h']
      this.form['eAP 30h'] = etapa4['eAP 30h']
      this.form['eAP 20h'] = etapa4['eAP 20h']
      this.form['eMulti Ampliada'] = etapa4['eMulti Ampliada']
      this.form['eMulti Complementar'] = etapa4['eMulti Complementar']
      this.form['eMulti Estratégica'] = etapa4['eMulti Estratégica']
      this.form['eSB I - Comum'] = etapa4['eSB I - Comum']
      this.form['eSB II - Comum'] = etapa4['eSB II - Comum']
      this.form['eSB I- Quil/Assent'] = etapa4['eSB I- Quil/Assent']
      this.form['eSB II- Quil/Assent'] = etapa4['eSB II- Quil/Assent']
    }
  },
  computed: {
    cidadeEstado() {
      return `Quantidade de equipes implantadas em ${this.dados?.etapa1.cidade.no_municipio} - ${this.dados?.etapa1.estado.uf}`
    },
    maskNumbers() {
      return Masks['number']
    },
  },
  methods: {
    salvarDados() {
      this.$emit('dados-etapa', { etapa: 'etapa4', dados: this.form })
    },
    voltar() {
      this.$emit('etapa-anterior')
    },
    proximo() {
      this.$refs.observer.validate().then((success) => {
        if (success) {
          this.salvarDados()
          this.$emit('proxima-etapa')
        } else {
          this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
            position: 'topRight',
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
<style>
.Etapa4 {
  height: auto !important;
}
</style>
<style scoped lang="scss">
table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 30px;
  @media screen and (max-width: 656px) {
    margin-bottom: 0;
  }
}
th,
td {
  border: 1px solid black;
  padding: 8px;
  text-align: left;
  width: 50%;
  input {
    height: auto !important;
    background-color: #fff;
    margin-bottom: 0 !important;
  }
}
th {
  background-color: #156082;
  color: white;
}

.container-buttons {
  justify-content: center !important;
}

@media screen and (max-width: 656px) {
  .container-table {
    overflow: auto;
    margin-bottom: 15px;
  }
  .container-buttons {
    gap: 20px;
    align-items: center;
  }
}
</style>
